module.exports = __webpack_public_path__ + "static/media/Kitchen.5b108078.mp3";